import { Routes } from '@angular/router';
import { apiConfigResolver } from '@df/api/config/api-config.resolver';
import { basketItemsStockReloadResolver } from '@df/basket/stock-reload.resolver';
import { CustomerNotLoggedGuard } from '@df/session/customer/customer-not-logged.guard';
import { CustomerReloadResolver } from '@df/session/customer/customer-reload.resolver';
import { DevOnlyGuard } from '@df/ui/dev-only.guard';
import { AppRootComponent } from './app-root.component';
import { BasketViewCmsComponent } from './basket/view/basket-view-cms.component';
import { BasketViewCmsResolver } from './basket/view/basket-view-cms.resolver';
import { Error500Component } from './catalog/error/error-500.component';
import { checkoutReplayResolver } from './module/sentry/checkout-replay.resolver';

export const BASKET_PATH = 'cart';

export const ROUTING_TABLE: Routes = [
    {
        path: '_library',
        canActivate: [DevOnlyGuard],
        resolve: {
            appData: apiConfigResolver
        },
        loadChildren: () =>
            import(
                /* webpackChunkName: "dfd.aw" */
                './module/df-demo/dfd.module'
            ).then(m => m.DfdModule)
    },
    {
        path: '_icmslibrary',
        canActivate: [DevOnlyGuard],
        resolve: {
            appData: apiConfigResolver
        },
        loadChildren: () => import(/* webpackChunkName: "icmsdfd.aw" */ '@icms/ui/icms-ui-demo.module').then(m => m.ICmsUiDemoModule)
    },
    {
        path: '',
        component: AppRootComponent,
        resolve: {
            appData: apiConfigResolver
        },
        children: [
            {
                path: 'account',
                loadChildren: () =>
                    import(
                        /* webpackChunkName: "account.async" */
                        './account/account.routes'
                    ).then(m => m.ACCOUNT_ROUTING_TABLE)
            },
            {
                path: 'login',
                canActivate: [CustomerNotLoggedGuard],
                loadChildren: () =>
                    import(
                        /* webpackChunkName: "login.async" */
                        './login/login.routes'
                    ).then(m => m.LOGIN_ROUTING_TABLE)
            },
            {
                path: BASKET_PATH,
                pathMatch: 'full',
                component: BasketViewCmsComponent,
                resolve: {
                    customer: CustomerReloadResolver,
                    stock: basketItemsStockReloadResolver,
                    layout: BasketViewCmsResolver
                }
            },
            {
                path: 'checkout',
                loadChildren: () =>
                    import(
                        /* webpackChunkName: "checkout.async" */
                        './checkout/checkout.routes'
                    ).then(m => m.CHECKOUT_ROUTING_TABLE),
                resolve: {
                    appData: apiConfigResolver,
                    replay: checkoutReplayResolver
                }
            },
            {
                path: 'search',
                loadChildren: () =>
                    import(
                        /* webpackChunkName: "search.async" */
                        './search/search.routes'
                    ).then(m => m.SEARCH_ROUTING_TABLE)
            },
            {
                path: 'error',
                pathMatch: 'full',
                component: Error500Component
            },
            {
                path: '**',
                pathMatch: 'full',
                loadChildren: () =>
                    import(
                        /* webpackChunkName: "catalog.async" */
                        './catalog/catalog.routes'
                    ).then(m => m.CATALOG_ROUTING_TABLE)
            }
        ]
    }
];
